import React, { useState } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Logo1 from '../assets/images/LogoPurple.svg';
import Logo2 from '../assets/images/Logo2.svg';
import Logo3 from '../assets/images/Logo3.svg';
import Logo4 from '../assets/images/bonhomme-folks.svg';
import NeonHeader from '../assets/images/folks-header-rouge.svg';
import Tache1 from '../assets/images/tache1.svg';
import Tache2 from '../assets/images/tache2.svg';
import Tache3 from '../assets/images/tache3.svg';
import LogoIntro from '../components/logoIntro.component';


const HomePage = () => {
  const [showIntro, setShowIntro] = useState(true);
  const navigate = useNavigate();

  return (
    <>
      <AnimatePresence>
        {showIntro && <LogoIntro onComplete={() => setShowIntro(false)} />}
      </AnimatePresence>

      <Stack
        alignItems='center'
        gap={4}
        pb={4}
        style={{
          backgroundColor: '#F9423A',
          minHeight: '100vh',
          color: '#000',
          textShadow: 'none',
          position: 'relative',
          overflow: 'hidden'
      }}>
        <svg style={{position: 'absolute', width: 0, height: 0}}>
          <defs>
            <filter id="roughEdges">
              <feMorphology operator="dilate" radius="8" in="SourceAlpha" result="dilated" />
              <feTurbulence type="fractalNoise" baseFrequency="0.03" numOctaves="3" result="noise" />
              <feDisplacementMap in="dilated" in2="noise" scale="8" xChannelSelector="R" yChannelSelector="G" result="displaced" />
              <feFlood floodColor="#000000" result="black" />
              <feComposite in="black" in2="displaced" operator="in" result="blackShape" />
              <feMerge>
                <feMergeNode in="blackShape" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            <filter id="inkSplatter">
              <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="4" result="noise" />
              <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" xChannelSelector="R" yChannelSelector="G" />
            </filter>
          </defs>
        </svg>
      {/* Taches grunge décoratives - Clusters */}
      {/* Cluster 1 - haut gauche */}
      <img src={Tache1} alt='' style={{position: 'absolute', top: '5%', left: '8%', width: '50px', transform: 'rotate(15deg)', zIndex: 999}} />
      <img src={Tache2} alt='' style={{position: 'absolute', top: '7%', left: '10%', width: '35px', transform: 'rotate(-25deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '6%', left: '12%', width: '28px', transform: 'rotate(45deg)', zIndex: 999}} />

      {/* Cluster 2 - haut droite */}
      <img src={Tache2} alt='' style={{position: 'absolute', top: '12%', right: '15%', width: '45px', transform: 'rotate(-35deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '10%', right: '13%', width: '32px', transform: 'rotate(60deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '8%', right: '5%', width: '38px', transform: 'rotate(120deg)', zIndex: 999}} />

      {/* Cluster 3 - milieu gauche */}
      <img src={Tache3} alt='' style={{position: 'absolute', top: '25%', left: '3%', width: '42px', transform: 'rotate(-45deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '27%', left: '5%', width: '30px', transform: 'rotate(85deg)', zIndex: 999}} />

      {/* Cluster 4 - milieu droite */}
      <img src={Tache2} alt='' style={{position: 'absolute', top: '35%', right: '10%', width: '48px', transform: 'rotate(25deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '37%', right: '12%', width: '36px', transform: 'rotate(-55deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '33%', right: '8%', width: '29px', transform: 'rotate(95deg)', zIndex: 999}} />

      {/* Cluster 5 - centre gauche */}
      <img src={Tache1} alt='' style={{position: 'absolute', top: '45%', left: '12%', width: '40px', transform: 'rotate(-15deg)', zIndex: 999}} />
      <img src={Tache2} alt='' style={{position: 'absolute', top: '47%', left: '14%', width: '33px', transform: 'rotate(75deg)', zIndex: 999}} />

      {/* Cluster 6 - centre droite */}
      <img src={Tache3} alt='' style={{position: 'absolute', top: '55%', right: '8%', width: '44px', transform: 'rotate(-65deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '53%', right: '6%', width: '31px', transform: 'rotate(35deg)', zIndex: 999}} />
      <img src={Tache2} alt='' style={{position: 'absolute', top: '57%', right: '10%', width: '27px', transform: 'rotate(105deg)', zIndex: 999}} />

      {/* Cluster 7 - bas gauche */}
      <img src={Tache2} alt='' style={{position: 'absolute', top: '65%', left: '5%', width: '46px', transform: 'rotate(50deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '67%', left: '7%', width: '34px', transform: 'rotate(-20deg)', zIndex: 999}} />

      {/* Cluster 8 - bas droite */}
      <img src={Tache1} alt='' style={{position: 'absolute', top: '75%', right: '18%', width: '41px', transform: 'rotate(-85deg)', zIndex: 999}} />
      <img src={Tache2} alt='' style={{position: 'absolute', top: '77%', right: '16%', width: '35px', transform: 'rotate(40deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '73%', right: '20%', width: '28px', transform: 'rotate(115deg)', zIndex: 999}} />

      {/* Cluster 9 - très bas gauche */}
      <img src={Tache3} alt='' style={{position: 'absolute', top: '85%', left: '20%', width: '39px', transform: 'rotate(-30deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '87%', left: '22%', width: '32px', transform: 'rotate(70deg)', zIndex: 999}} />

      {/* Taches isolées pour variation */}
      <img src={Tache2} alt='' style={{position: 'absolute', top: '18%', left: '25%', width: '37px', transform: 'rotate(-75deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '40%', right: '25%', width: '43px', transform: 'rotate(20deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '70%', left: '30%', width: '36px', transform: 'rotate(-50deg)', zIndex: 999}} />
      <Stack gap={3} maxWidth='800px'>
        <Stack justifyContent='center' alignItems='center' p={4} gap={2}>
          <img src={NeonHeader} alt='' style={{maxHeight: '500px'}} />
          <Typography fontSize={{xs: 18, md: 22}} align='center' className='blueHighlight'>
          De Tanzanie aux causses du Quercy, du singeli à la tradition occitane
          ou jusqu'au chaâbi, Folks poursuit ses explorations à la jonction entre
          musiques traditionnelles et musiques actuelles. <br/><br/>

          Des concerts, discussions et soirées clubs où s'entremêlent instruments
          traditionnels, chants contestataires et basses fréquences dans une exploration
          hypnotique comme une ouverture à l'autre. En questionnant nos passés
          et nos sonorités modernes, Folks s'engage à convoquer les histoires et les
          terroirs pour sublimer ces artistes qui donnent du sens aux dancefloors.
          </Typography>
        </Stack>
      </Stack>
      <Stack direction='row' gap={0} justifyContent='center' alignItems='flex-end' sx={{display: {xs: 'none', md: 'flex'}, width: '100%', paddingBottom: '50px'}}>
        <img src={Logo4} alt='' style={{height: '120px', marginLeft: '-20px'}} />
        <img src={Logo4} alt='' style={{height: '120px', marginLeft: '-20px', transform: 'scaleX(-1)'}} />
        <img src={Logo4} alt='' style={{height: '120px', marginLeft: '-20px'}} />
        <img src={Logo4} alt='' style={{height: '120px', marginLeft: '-20px', transform: 'scaleX(-1)'}} />
        <img src={Logo4} alt='' style={{height: '120px', marginLeft: '-20px'}} />
      </Stack>
      <Stack gap={3} maxWidth='800px'>
        <Stack style={{
          borderRadius: '20px',
          border: '2px solid #000',
          transform: 'rotate(-2deg)',
          boxShadow: '8px 8px 0 0 #000'
          }}
          p={3}
          m={2}>
          <Typography fontSize={{xs: 16, md: 28}} align='center' color='#000'>
          Cité de la musique - Embobineuse<br/>Micro Kawa<br/>Petit Cab – Friche la Belle de Mai – <br/>UNITÉ.22
          </Typography>
        </Stack>
      </Stack>
      <Stack width='100%' p={6} alignItems='center' mt={4} position='relative'>
        <Stack maxWidth='700px' alignItems='center' justifyContent='center' spacing={{xs: 0, md: -1.5}}>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            ARSENAL MIKEBE (LIVE)
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            CIGARRA
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            CINNA PEYGHAMY (LIVE)
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            DERBCORE (LIVE)
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            DJ TRAVELLA
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            ELIZABETH VOGLER (LIVE)
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            HHY & THE KAMPALA UNIT (LIVE)
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            KAMOUN
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            LE FRIT (LIVE)
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            MC KER·6 (LIVE)
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            MC YALLAH (LIVE)
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            MIHAELA MÎNDRU
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            MONA HKL
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            NADIA EL HAKIM
          </Typography>
          <Typography
            sx={{
              color: '#F9423A',
              fontWeight: 700,
              display: 'inline-block',
              width: 'fit-content',
              filter: 'url(#roughEdges)',
              letterSpacing: '0.05em',
              fontFamily: 'DroulersClarendon-Line',
              textAlign: 'center'
            }}
            fontSize={{xs: 20, md: 30}}>
            NUÈIT (LIVE)
          </Typography>
        </Stack>
      </Stack>
      <Button
        onClick={() => navigate('/programmation')}
        style={{
          textTransform: 'uppercase',
          border: '2px solid #000',
          backgroundColor: '#000',
          color: '#F9423A',
          fontSize: '22px',
          paddingLeft: '10px',
          paddingRight: '10px',
          borderRadius: '10px',
          marginTop: '3rem',
          width: '300px',
          fontWeight: 700,
          transform: 'rotate(-1.5deg)',
          boxShadow: '6px 6px 0 0 #000'
        }}
        >Programmation</Button>
      <Button
        onClick={() => {
          window.location.href='mailto:contact.folksfestival@gmail.com'
        }}
        style={{
          paddingTop: '15px',
          textDecoration: 'underline',
          color: '#000',
          fontSize: '16px',
          paddingLeft: '10px',
          paddingRight: '10px',
          borderRadius: '10px',
          width: '300px'
        }}>{`Nous contacter`}</Button>
      </Stack>
    </>
  )
}

export default HomePage;